/**
 * Kho thiết bị kết nối — thiết bị phát hiện qua DV008 chờ duyệt đăng ký.
 * Khớp `apps/api/src/kho-thiet-bi/kho-thiet-bi.controller.ts` (ngoài OpenAPI 1.0.1).
 */
import { chuoiTruyVan, goi, LoiApi } from './goi-chung';
import type { TrangDuLieu } from './thiet-bi-api';

export { LoiApi };

export type TrangThaiKho = 'phat_hien' | 'trong_kho';
export type LoaiThietBiKho = 'cum_thu_phat_thanh' | 'bang_tin_dien_tu';
export type PhuongThucKetNoiKho = 'gian_tiep' | 'truc_tiep';

export interface DongKho {
  id: string;
  loaiThietBi: string;
  cumLoaId: string;
  tenThietBi: string | null;
  tenLoaiThietBi: string | null;
  nguonId: string | null;
  tenNguon: string | null;
  tenXa: string | null;
  maThon: string | null;
  maNhaCungCap: string;
  tenNhaCungCap: string | null;
  boTuongThichId: string | null;
  /** `truc_tiep`: thiết bị MQTT tự kích hoạt; `gian_tiep`: qua bộ tương thích. */
  phuongThucKetNoi: PhuongThucKetNoiKho;
  amLuong: number | null;
  nhietDo: number | null;
  trangThaiHoatDong: string | null;
  trangThaiKetNoi: string | null;
  noiDungPhat: string | null;
  phienBanUngDung: string | null;
  soLanGhiNhan: number;
  lanDauThay: string;
  lanCuoiThay: string;
  trangThai: TrangThaiKho;
  duaVaoKhoLuc: string | null;
}

export interface KetQuaDangKy {
  tong: number;
  /** `canKichHoat` (chỉ thiết bị trực tiếp): đã đăng ký nhưng chưa hoàn tất DV018. */
  thanhCong: { id: string; cumLoaId: string; deviceId: string; canKichHoat?: boolean }[];
  loi: { id: string; cumLoaId: string; thongBao: string }[];
}

export interface LocKho {
  trangThai: TrangThaiKho;
  loaiThietBi: LoaiThietBiKho;
  nguonId?: string;
  keyword?: string;
  page?: number;
  pageSize?: number;
}

export const khoThietBiApi = {
  danhSach: (loc: LocKho, signal?: AbortSignal) =>
    goi<TrangDuLieu<DongKho>>(`/api/v1/device-inventory${chuoiTruyVan({ ...loc })}`, { signal }),
  duaVaoKho: (ids: string[]) =>
    goi<{ soDong: number }>('/api/v1/device-inventory/stage', { phuongThuc: 'POST', than: { ids } }),
  xoaKhoiKho: (ids: string[]) =>
    goi<{ soDong: number }>('/api/v1/device-inventory/unstage', { phuongThuc: 'POST', than: { ids } }),
  sua: (id: string, than: { tenThietBi?: string; nguonId?: string; maThon?: string }) =>
    goi<DongKho>(`/api/v1/device-inventory/${encodeURIComponent(id)}`, { phuongThuc: 'PATCH', than }),
  dangKy: (than: {
    ids?: string[];
    tatCa?: boolean;
    nguonId?: string;
    locNguonId?: string;
    /** Nhà cung cấp cho thiết bị kết nối trực tiếp (DV018 không mang mã nhà cung cấp). */
    maNhaCungCap?: string;
    loaiThietBi: LoaiThietBiKho;
  }) => goi<KetQuaDangKy>('/api/v1/device-inventory/register', { phuongThuc: 'POST', than }),
};

export type KhoThietBiApi = typeof khoThietBiApi;
